<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication">Dedicated to Giulia and Maurizio, <br/>and to their words: <br/>Begin. Go on.<br/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// threeimperfect_00000.vue?6310947e